import { DateTime } from "luxon";
const timeZone = "America/Bogota";

const getDateTime = () => DateTime.local().setZone(timeZone);
const getTimeStamp = () => DateTime.local().setZone(timeZone).valueOf();
const getTimeStampWithExtraHours = (hours: number) =>
  DateTime.local().setZone(timeZone).plus({ hours }).valueOf();

export default {
  getDateTime,
  getTimeStamp,
  getTimeStampWithExtraHours,
};
